import React from 'react';
// import { motion } from 'framer-motion';
import { breakpoints, colors } from '../config';

const Art = props => (
  <div className="art">
    <div className="art-square-1" />
    <div className="art-square-2" />

    <style jsx>{`
      .art {
        position: absolute;
        top: -100px;
        right: 15%;
      }

      @media screen and (max-width: ${breakpoints.md}) {
        .art {
          display: none;
        }
      }

      .art-square-1 {
        width: 320px;
        height: 320px;
        transform: rotate(-30deg);
        opacity: 0.5;
        border-radius: 42px;
        background-color: ${colors.pale};
      }

      .art-square-2 {
        width: 620px;
        height: 320px;
        transform: rotate(-30deg);
        opacity: 0.5;
        border-radius: 42px;
        background: linear-gradient(180deg, #efe9e5, rgba(255, 255, 255, 0));
        position: absolute;
        left: 300px;
        top: 180px;
      }
    `}</style>
  </div>
);

export default Art;
